import { render, staticRenderFns } from "./ListSupportedTokenView.vue?vue&type=template&id=539f98ee"
import script from "./ListSupportedTokenView.vue?vue&type=script&lang=ts"
export * from "./ListSupportedTokenView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports